<template>
  <RouterLink
    v-if="isInternalPath || isSameHostnameUrl"
    class="link"
    :to="isSameHostnameUrl ? hrefWithoutHostname : href"
    data-test-id="internal-or-external-link"
  >
    <slot />
  </RouterLink>
  <a
    v-else
    class="link"
    :href="href"
    data-test-id="internal-or-external-link"
  >
    <slot />
  </a>
</template>

<script>
export default {
  name: 'InternalOrExternalLink',
  props: {
    href: {
      type: String,
      required: true
    }

  },
  computed: {
    isInternalPath () {
      if (!this.href) return false

      return _.startsWith(this.href, '/')
    },
    isSameHostnameUrl () {
      if (!this.href) return false

      return this.$isUrlSameHostName(this.href)
    },
    hrefWithoutHostname () {
      if (!this.href) return

      try {
        const parsedUrl = new URL(this.href)
        return parsedUrl.pathname + parsedUrl.search + parsedUrl.hash
      } catch (e) {
        return this.href
      }
    }
  }
}
</script>

<style scoped>
.link {
  color: inherit;
  text-decoration: none;
  cursor: pointer;
}
.link.text-underline {
  text-decoration: underline;
}
.link.text-underline {
  text-decoration: underline;
}
</style>
